// extracted by mini-css-extract-plugin
export default {"contUs":"style_contUs__sY+O4","txt":"style_txt__YpGQ4","img":"style_img__0hs5E"};